module.exports = __webpack_public_path__ + "static/media/998041.6154bc8b.jpg";